<ng-container *ngIf="libraries.length === 0 && !isLoading">
    <div class="mt-3">
        <div *ngIf="isAdmin" class="d-flex justify-content-center">
            <p>There are no libraries setup yet. Configure some in <a routerLink="/admin/dashboard" fragment="libraries">Server settings</a>.</p>
        </div>
        <div *ngIf="!isAdmin" class="d-flex justify-content-center">
            <p>You haven't been granted access to any libraries.</p>
        </div>
    </div>
</ng-container>

<app-carousel-reel [items]="inProgress" title="On Deck" (sectionClick)="handleSectionClick($event)">
    <ng-template #carouselItem let-item let-position="idx">
        <app-series-card [data]="item" [libraryId]="item.libraryId" (reload)="reloadInProgress($event)" (dataChanged)="reloadInProgress($event)"></app-series-card>
    </ng-template>
</app-carousel-reel>

<!-- TODO: Refactor this so we can use series actions here -->
<app-carousel-reel [items]="recentlyUpdatedSeries" title="Recently Updated Series" (sectionClick)="handleSectionClick($event)">
    <ng-template #carouselItem let-item let-position="idx">
        <app-card-item [entity]="item" [title]="item.seriesName" [imageUrl]="imageService.getSeriesCoverImage(item.seriesId)"
        [supressArchiveWarning]="true" (clicked)="handleRecentlyAddedChapterClick(item)" [count]="item.count"></app-card-item>
    </ng-template>
</app-carousel-reel>

<app-carousel-reel [items]="recentlyAddedSeries" title="Newly Added Series" [clickableTitle]="false">
    <ng-template #carouselItem let-item let-position="idx">
        <app-series-card [data]="item" [libraryId]="item.libraryId" (dataChanged)="loadRecentlyAddedSeries()"></app-series-card>
    </ng-template>
</app-carousel-reel>

<!-- <app-carousel-reel [items]="recentlyAddedChapters" title="Recently Added" (sectionClick)="handleSectionClick($event)">
    <ng-template #carouselItem let-item let-position="idx">
        <app-card-item [entity]="item" [title]="item.title" [subtitle]="item.seriesName" [imageUrl]="imageService.getRecentlyAddedItem(item)"
        [supressArchiveWarning]="true" (clicked)="handleRecentlyAddedChapterClick(item)"></app-card-item>
    </ng-template>
</app-carousel-reel> -->
